var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213.278,
    height: 92.436,
    viewBox: "0 0 213.278 92.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162445",
    "data-name": "\\uADF8\\uB8F9 162445",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162436",
    "data-name": "\\uADF8\\uB8F9 162436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_83866",
    "data-name": "\\uD328\\uC2A4 83866",
    d: "M657.415,296.314h0a65.98,65.98,0,0,0-65.98-65.979H472.593a26.456,26.456,0,0,1-26.456-26.456h0",
    transform: "translate(-446.137 -203.878)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_83868",
    "data-name": "\\uD328\\uC2A4 83868",
    d: "M635.983,292.452h0A65.979,65.979,0,0,0,570,226.472",
    transform: "translate(-424.965 -200.016)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.6e98fa5c43320dd94dbf74e03482329c.svg";
export { ForwardRef as ReactComponent };